import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=67fb8122&scoped=true&"
import script from "./contacts.ts?vue&type=script&lang=ts&"
export * from "./contacts.ts?vue&type=script&lang=ts&"
import style0 from "./contacts.scss?vue&type=style&index=0&id=67fb8122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67fb8122",
  null
  
)

export default component.exports